import React from "react";
import { BrowserRouter, Switch, Route } from "react-router-dom";
import { Routes } from "./Routes";
import Layout from "./Components/Layout";
import Home from "./Views/Home";
import { Materia } from "./Views/Materia";
import { Production } from "./Views/Production";
import { ProtectedRoutes } from "./Components/ProtectedRoutes";
import Editor from "./Views/Editor";
import { ToastContainer } from "react-toastify";
import { Profile } from "./Views/Profile";
import { Register } from "./Views/Register";

function App() {
  return (
    <BrowserRouter>
      <ToastContainer progressClassName="toast-progress" autoClose={2500} />
      <Switch>
        <Route path={`${Routes.REGISTER}`} component={Register} />

        <ProtectedRoutes>
          <Layout>
            <Route path={`${Routes.EDITOR}`} component={Editor} />
            <Route path={Routes.HOME} component={Home} />
            <Route path={`${Routes.MATERIA}/:materia`} component={Materia} />
            <Route path={`${Routes.PRODUCAO}`} component={Production} />
            <Route path={`${Routes.PERFIL}`} component={Profile} />
          </Layout>
        </ProtectedRoutes>
      </Switch>
    </BrowserRouter>
  );
}

export default App;
